import AjaxFormErrorHandler from 'Scripts/common/ajax-form-error-handler';
import ColourPicker from 'Scripts/common/colour-picker';
import fetchHtml from 'Scripts/common/fetch-html';
import fetchJson from 'Scripts/common/fetch-json';
import Fetcher from 'Scripts/common/fetcher';
import Form from 'Scripts/common/form';
import showErrorBar from 'Scripts/common/show-error-bar';

export default class WidgetBuilder {
	constructor() {
		this.timer;

		this.currentFormData;

		this.modal = $("#widget-builder-modal");

		this.errorHandler  = new AjaxFormErrorHandler();

		this.widgetsFetcher = new Fetcher({
			element: $("#js-saved-widgets-fetcher"),
			callback: this.bindEvents.bind(this),
		});

		this.bindEvents();

		this.savedTab = new bootstrap.Tab('#tab-widgets-saved');
	}

	bindEvents() {
		$(".js-open-widget-builder").off().on('click', this.onClickOpenWidgetBuilder.bind(this));
	}

	onClickOpenWidgetBuilder(e) {
		console.log("WidgetBuilder.onClickOpenWidgetBuilder");

		this.modalFetcher = new Fetcher({
			element: $("#js-fetcher-widget-builder"),
			data: $(e.currentTarget).data(),
			modal: this.modal,
			callback: this.onOpenModal.bind(this),
		});
	}

	onOpenModal() {
		console.log("WidgetBuilder.onOpenModal");

		this.formEl = $("#widget-builder-form");
		this.previewContainer = $("#js-widget-builder-preview");

		this.setPreviewHtml("");
		this.validateAndPreview(null, true);

		new ColourPicker({
			parent: this.modal
		});

		this.form = new Form({
			form:     this.formEl,
			callback: this.onSubmit.bind(this),
		});

		this.bindModalEvents();
	}

	bindModalEvents() {
		this.formEl.find("input,select").on("keyup change", this.validateAndPreview.bind(this));
		this.formEl.find(".js-actions").on("change", this.onChangeAction.bind(this));

		// Show/hide parts of form based on other parts

		$("#pageId").on("change", e => {
			$(".js-widget-page-only").collapse(e.currentTarget.value.length ? "show" : "hide")
		});

		const donationType = $("input[name='settings.donationType']");
		donationType.on("change", e => {
			const selectedDonationType = donationType.filter(":checked").val();
			$(".js-widget-donation-choice-only").collapse(selectedDonationType == "BOTH" ? "show" : "hide")
		});

		const showPresetAmounts = $("input[name='settings.showPresetAmounts']");
		showPresetAmounts.on("change", e => {
			const selectedShowPresetAmounts = showPresetAmounts.filter(":checked").val();
			$(".js-widget-preset-only").collapse(selectedShowPresetAmounts == "true" ? "show" : "hide")
		});

		const showProgressButton = $("input[name='settings.showProgressButton']");
		showProgressButton.on("change", e => {
			const selectedShowProgressButton = showProgressButton.filter(":checked").val();
			$(".js-widget-with-button-only").collapse(selectedShowProgressButton == "true" ? "show" : "hide")
		});

		const primaryButtonFixed = $("input[name='settings.primaryButtonFixed']");
		primaryButtonFixed.on("change", e => {
			const selectedPrimaryButtonFixed = primaryButtonFixed.filter(":checked").val();
			$(".js-widget-fixed-only").collapse(selectedPrimaryButtonFixed == "true" ? "show" : "hide")
		});
	}

	onSubmit(e) {
		console.log("WidgetBuilder.onSubmit()", e);
		if(e?.payload?.id == null) return;

		this.modal.modal("hide");

		if(e.payload?.adminId) {
			this.widgetsFetcher.fetch();
			this.savedTab.show();
			$("main").animate({ scrollTop: 0}, "slow");
		}

		const codeModal = $("#widget-code-modal");

		this.codeModal = new Fetcher({
			element: $("#js-fetcher-widget-code"),
			data: {
				id: e.payload.id,
				status: this.formEl.find("#id").val() ? "edit" : "new"
			},
			modal: codeModal,
		});

		codeModal.modal("show");
	}

	/**
	 * Validate - this returns JSON and we use it to show errors on the form
	 * Preview - this returns HTML and we add it to preview container, using shadowDOM to mimic how the widget actually loads
	 */
	async validateAndPreview(e, force) {
		console.log("WidgetBuilder.validateAndPreview", {force: force});

		clearTimeout(this.timer);

		// Wait for 300ms of non-typing, and make sure form data has actually changed
		this.timer = setTimeout(async () => {
			if(!force && !this.hasFormDataChanged()) return;

			console.log("WidgetBuilder.validateAndPreview", "Date has changed");

			const { success, result } = await fetchJson(this.previewContainer.data('validateTarget'), {
				method: 'POST',
				body: new FormData(this.formEl[0]),
			});

			if(!success) {
				showErrorBar();
				return;
			}

			if(!result.success) {
				this.errorHandler.handleErrors(result.payload.validation, {
					disableScroll: true
				});

				return;
			}

			this.errorHandler.clear();

			const html = await fetchHtml(this.previewContainer.data('previewTarget'), {
				method: 'POST',
				body: new FormData(this.formEl[0]),
			});

			this.setPreviewHtml(html);
		}, 300);
	}

	setPreviewHtml(html) {
		if(html == null) return;

		const shadowDom = this.previewContainer[0].shadowRoot ?? this.previewContainer[0].attachShadow({
			mode: "open"
		});

		shadowDom.innerHTML = html;
	}

	getFormDataMap() {
		const formData = new FormData(this.formEl[0]);
		const data = {};
		formData.forEach((value, key) => data[key] = value);
		return data;
	}

	/**
	 * A lot of keyup triggers won't actually involve changing data, e.g. pressing an arrow key
	 * So we want to check the data has actually changed before pinging our endpoints
	 */
	hasFormDataChanged() {
		const newFormData = this.getFormDataMap();
		const hasChanged = JSON.stringify(this.currentFormData) !== JSON.stringify(newFormData)
		this.currentFormData = newFormData;
		return hasChanged;
	}

	/**
	 * This changes the button text based on the button action
	 */
	onChangeAction(e) {
		console.log("WidgetBuilder.onChangeAction", $(e.currentTarget).val());

		const trigger = $(e.currentTarget);
		const actions = $(trigger.data('target'));

		const action = $(trigger.data('target')).filter((i,el) => {
			return $(el).data('action') == trigger.val();
		});

		if(action.length) {
			$(action.data('target').replaceAll("\.", "\\.")).val(action.data('text'));
		}
	}
}